export default __webpack_public_path__ + "static/media/itNum-min.863eb95f.webp";